<template>
  <div class="layout-only-content">
    <header
      aria-label="사이트 머리글"
      aria-hidden="true"
      class="layout-only-content-logo__wrap"
    >
      <img
        class="layout-only-content-logo light-only"
        src="@/assets/img/logo_big.png"
        alt=""
      />
      <img
        class="layout-only-content-logo dark-only"
        src="@/assets/img/logo_big_white.png"
        alt=""
      />
    </header>
    <main id="main" role="main" tabindex="-1" class="layout-only-content-main">
      <section class="error_card" aria-labelledby="error-title">
        <div class="error__content" role="alert">
          <span class="error__icon">
            <img
              v-if="lightIcon"
              :src="lightIcon"
              :alt="iconAlt"
              class="light-only"
            />
            <img
              v-if="darkIcon"
              :src="darkIcon"
              :alt="iconAlt"
              class="dark-only"
            />
          </span>

          <h1 id="error-title" class="error__title">{{ title }}</h1>
          <p class="error__desc" v-dompurify-html="desc"></p>
        </div>
        <div class="btn__wrap type-bottom" aria-label="이동 옵션">
          <!-- <button
            type="button"
            @click="goBack"
            class="btn btn--medium_blue btn--m"
          >
            <span aria-hidden="true"
              ><img src="@/assets/img/icon_prev.svg" alt=""
            /></span>
            이전 페이지로 이동
          </button> -->

          <router-link to="/" class="btn btn--m btn--blue" @click="clear">
            홈페이지로 이동
            <span aria-hidden="true"
              ><img src="@/assets/img/icon_arrow-right.svg" alt="" /></span
          ></router-link>
        </div>
      </section>
    </main>
  </div>
</template>
<script>
import { computed } from "vue";
import { useRouter } from "vue-router";

export default {
  props: {
    type: { type: String, default: "warn" }, // warn | success | fail | guide
    title: { type: String, default: "서버 내부 오류가 발생했습니다." },
    desc: {
      type: String,
      default:
        "죄송합니다.<br>현재 웹사이트에 기술적인 문제가 발생했습니다.<br>잠시 후 다시 시도해 주십시오. 불편을 드려 죄송합니다.",
    },
  },
  setup(props) {
    const router = useRouter();

    const iconMap = {
      warn: [
        new URL("@/assets/img/img_warning.png", import.meta.url).href,
        new URL("@/assets/img/img_warning_white.png", import.meta.url).href,
        "경고 아이콘",
      ],
      success: [
        new URL("@/assets/img/img_success.png", import.meta.url).href,
        new URL("@/assets/img/img_success_white.png", import.meta.url).href,
        "성공 아이콘",
      ],
      fail: [
        new URL("@/assets/img/img_fail.png", import.meta.url).href,
        new URL("@/assets/img/img_fail_white.png", import.meta.url).href,
        "실패 아이콘",
      ],
      guide: [
        new URL("@/assets/img/img_guide.png", import.meta.url).href,
        new URL("@/assets/img/img_guide_white.png", import.meta.url).href,
        "안내 아이콘",
      ],
    };

    const clear = () => {
      sessionStorage.clear();
    };

    const goBack = () => {
      // history length 체크 후 뒤로 가기, 없으면 홈으로 이동
      clear();
      if (window.history.length > 1) {
        router.go(-1);
      } else {
        router.push("/");
      }
    };
    const deleteAllCookiesWithDomain = () => {
      const cookies = document.cookie.split(";");

      cookies.forEach((cookie) => {
        const eqPos = cookie.indexOf("=");
        const name = eqPos > -1 ? cookie.slice(0, eqPos).trim() : cookie.trim();

        // 기본 경로 삭제
        document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/;`;
      });
    };

    const icons = computed(() => iconMap[props.type] || []);
    const lightIcon = computed(() => icons.value[0]);
    const darkIcon = computed(() => icons.value[1]);
    const iconAlt = computed(() => icons.value[2]);

    // html에서 사용될 데이터 정의
    return {
      goBack,
      lightIcon,
      darkIcon,
      iconAlt,
      clear,
    };
  },
};
</script>
